import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';

export default function OverviewKpi({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/grove/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiCard
          title="Total Deployed"
          variant="dai"
          data={data}
          field="debt"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: tokensMapping('DAI')
              }
            }
          }}
        />
        <KpiCard
          title="Total Collateral backing DAI"
          data={data}
          field="collateral"
          options={{
            valueOptions: {
              currencyValueOptions: { currency: 'USD' }
            },
            valueTrendOptions: {
              currencyValueOptions: { currency: 'USD' }
            }
          }}
        />
      </Flex>
    );
  }

  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiSkeleton />
      <KpiSkeleton />
    </Flex>
  );
}
